import React, { useState } from 'react'
import { browserHistory } from 'react-router'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import Page from 'layouts/Page'
import { Button } from '@surecompanies/core_components'
import useFeatureFlags from 'hooks/useFeatureFlags'
import PlanBenefitsExcelModal from './components/PlanBenefitsExcelModal'
import PlanSnapshotsTable from './components/PlanSnapshotsTable'
import { PLAN_MANAGEMENT_V2, planOverridesPath } from './paths'

export default function PlanManagementV2() {
  const [isExcelModalOpen, setIsExcelModalOpen] = useState(false)
  const { flags } = useFeatureFlags()
  const isPlanBenefitsExcelEnabled =
    flags['admin.plan-management-plan-benefits-csv-enabled'] === true

  return (
    <Page
      title="Plan Information"
      action={
        <div style={{ display: 'flex', gap: 8 }}>
          {isPlanBenefitsExcelEnabled && (
            <Button onClick={() => setIsExcelModalOpen(true)}>
              Plan Benefits CSV
            </Button>
          )}
          <Button
            type="primary"
            onClick={() => browserHistory.push(planOverridesPath())}
          >
            Manage Overrides
          </Button>
        </div>
      }
      breadcrumb={
        <BreadcrumbNav
          items={[
            { title: 'Plans', path: `/${PLAN_MANAGEMENT_V2}` },
            { title: 'Plan Information' },
          ]}
        />
      }
    >
      {isPlanBenefitsExcelEnabled && (
        <PlanBenefitsExcelModal
          open={isExcelModalOpen}
          onClose={() => setIsExcelModalOpen(false)}
        />
      )}
      <PlanSnapshotsTable />
    </Page>
  )
}
